module.exports = __webpack_public_path__ + "static/media/_GPX1088.95fba8be.jpeg";